// Angular
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

// Formly
import { FieldType } from '@ngx-formly/core';

// Kendo
import { IntlService } from '@progress/kendo-angular-intl';
import { Observable } from 'rxjs/Observable';

// Services
import { WISEService } from 'app/_services';

// Models
import { CaseShort } from 'app/_models';
import { PoliceRegion } from 'app/_models';

@Component({
    selector: 'formly-field-policeregion',
    templateUrl: './policeregion.type.component.html',
})
export class FormlyFieldPoliceRegion extends FieldType implements OnInit, OnDestroy {
    public listItems: Array<PoliceRegion> = [];
    private listPR: Array<PoliceRegion> = [];
    public caseShort: CaseShort = new CaseShort();
    public data;

    constructor(
        private route: ActivatedRoute,
        private wiseService: WISEService,
    ) {
        super();

        this.route.params.subscribe(params => {
            const caseData: CaseShort = new CaseShort();
            caseData.CaseID = params['caseID'];

            this.wiseService.getPoliceRegions(caseData.CaseID).subscribe(data => {
                this.listItems = data;
                this.listPR = data;
            });
        });
    }

    public handleFilter(value) {
        this.listItems = this.listPR.filter((s) => s.Description.toLowerCase().indexOf(value.toLowerCase()) !== -1);
    }

    public ngOnInit(): void {

    }

    public ngOnDestroy(): void {
    }
}
